// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import './style/index.scss';

import install from '@/utils';
Vue.use(install);

Vue.config.productionTip = false;

import i18n from '@/locales';

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
